function NotFound() {
  return (
    <main className="bg-gradient-to-r from-backgradientbot to-backgradienttop h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-red-600">404</h1>
        <p className="text-3xl font-medium white">Not Found</p>
      </div>
    </main>
  );
}
export default NotFound;
